/* eslint-disable max-len */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-use-before-define */
import {
    forEach,
    find,
    includes,
    get,
} from 'lodash';
import {
    EXPRESSION_TYPE_TOKEN,
    EXPRESSION_TYPE_FIELD_R,
    TOKEN_TYPE_FIELD,
    TOKEN_TYPE_FIELD_R,
    TOKEN_TYPE_LOGIC,
    TOKEN_TYPE_QUERYSYMBOL,
    TOKEN_TYPE_TREE,
    TOKEN_TYPE_SPECIALQUERY,
    TOKEN_TYPE_SPACE,
    TOKEN_TYPE_OPERATOR,
} from '../../constants';

const maxGap = 25;

/**
 * 将expressionTree 转换为html 字符串
 * @param {*} expressionTree
 */
function getHtmlStrByExpressionTree(expressionTree, range) {
    const htmlStr = _getHtmlStr(expressionTree, range);
    return htmlStr;
}

/**
 * 将expressionTree 转换为str 并剔除不需要的token或者expression
 *
 */

function getStrRemoveRFieldByExpressionTree(expressionTree, config) {
    const htmlStr = _getStrRemoveRField(expressionTree, config);
    return htmlStr;
}

export {
    getHtmlStrByExpressionTree,
    getStrRemoveRFieldByExpressionTree,
};

/**
 * @param {obj} expressionTree 结构化语法树
 * 主要作用是递归语法树将其转换为一个html字符串
 */
// 之所以错误不显示，可能是因为这里没有添加相应的type
function _getHtmlStr(expressionTree, range) {
    let htmlStr = '';
    const htmlStrArr = [];
    const htmlType = [
        TOKEN_TYPE_FIELD,
        TOKEN_TYPE_FIELD_R,
        TOKEN_TYPE_LOGIC,
        TOKEN_TYPE_QUERYSYMBOL,
        TOKEN_TYPE_TREE,
        TOKEN_TYPE_SPECIALQUERY,
        TOKEN_TYPE_OPERATOR,
    ];
    if (expressionTree && expressionTree.children) {
        const { errorData } = expressionTree;
        forEach(expressionTree.children, (item) => {
            if (item.expressionType === EXPRESSION_TYPE_TOKEN) {
                const classNameArr = [];
                classNameArr.push(item.data.type);
                if (item.data.exteralClass !== '') {
                    classNameArr.push(item.data.exteralClass);
                }
                classNameArr.push(`ed_tk_${item.data.id}`);
                let errorCode = '';
                if (errorData && errorData.tokenError) {
                    const error = find(errorData.tokenError, {
                        id: item.data.id,
                    });
                    if (error) {
                        classNameArr.push('error');
                        errorCode = error.errorCode;
                    }
                }
                htmlStr = item.data.value;
                const errorCodeHtml = errorCode ? `data-error-code="${errorCode}"` : '';
                const isActiveToken = range && item.data.start - maxGap <= range.start && item.data.end + maxGap >= range.end;
                if (item.data.type === TOKEN_TYPE_FIELD) {
                    classNameArr.push(`ed_tk_${item.data.value}`);
                }
                if (includes(htmlType, item.data.type) || errorCodeHtml || isActiveToken) {
                    htmlStr = `<span class="ed_tk ${classNameArr.join(' ')}" ${errorCodeHtml}>${item.data.value}</span>`;
                }
            } else {
                htmlStr = _getHtmlStr(item, range);
            }
            htmlStrArr.push(htmlStr);
        });
        const errorCodeArr = [];
        const expClassNameArr = [];
        if (errorData && errorData.expressionError && errorData.expressionError.length > 0) {
            expClassNameArr.push('error');
            forEach(errorData.expressionError, (item) => {
                errorCodeArr.push(item.errorCode);
            });
        }
        const errorCodeHtml = errorCodeArr.join(',') ? `data-error-code="${errorCodeArr.join(',')}"` : '';
        htmlStr = `<span class="ed_ep ${expClassNameArr.join(' ')}" ${errorCodeHtml}>${htmlStrArr.join('')}</span>`;
    }

    return htmlStr;
}

function _getStrRemoveRField(expressionTree) {
    /**
    * 需要移除R, R前后的逻辑词，R与中间的空格
    * R: (xx) xxx || xxx R: (xx) || R: (xx) logic xxx || xxx  logic R: (xx)
    */
    const strArr = [];
    let str = '';
    if (expressionTree && expressionTree.children) {
        forEach(expressionTree.children, (item, index) => {
            if (item.expressionType === EXPRESSION_TYPE_FIELD_R
        || (get(item, 'data.type') === TOKEN_TYPE_LOGIC
            && (get(expressionTree, `children[${index - 2}].expressionType`) === EXPRESSION_TYPE_FIELD_R
            || get(expressionTree, `children[${index + 2}].expressionType`) === EXPRESSION_TYPE_FIELD_R))
        || (get(item, 'data.type') === TOKEN_TYPE_SPACE
            && (get(expressionTree, `children[${index - 1}].expressionType`) === EXPRESSION_TYPE_FIELD_R
            && get(expressionTree, `children[${index + 1}].data.type`) === TOKEN_TYPE_LOGIC))
        || (get(item, 'data.type') === TOKEN_TYPE_SPACE
            && (get(expressionTree, `children[${index - 1}].data.type`) === TOKEN_TYPE_LOGIC
                && get(expressionTree, `children[${index + 1}].expressionType`) === EXPRESSION_TYPE_FIELD_R))
            ) {
                return;
            }
            if (item.expressionType === EXPRESSION_TYPE_TOKEN) {
                str = item.data.value;
            } else {
                str = _getStrRemoveRField(item);
            }
            strArr.push(str);
        });
    }
    return strArr.join('');
}
